<ng-template appSpotlightMenuInflatorContainer></ng-template>
